<div>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.9981 0C7.54336 0.000435883 5.17315 0.890077 3.33232 2.50196C1.49149 4.11384 0.306588 6.33714 0 8.75461H2.59985C2.87907 7.68089 3.50987 6.72972 4.39306 6.05063C5.27626 5.37153 6.36177 5.00302 7.47896 5.00302C8.59616 5.00302 9.68167 5.37153 10.5649 6.05063C11.4481 6.72972 12.0789 7.68089 12.3581 8.75461H19.9962C19.6898 6.33708 18.5049 4.11368 16.6641 2.50177C14.8232 0.889858 12.4529 0.000273524 9.9981 0Z"
      fill="white"
    />
    <path
      d="M17.4001 11.249C17.1209 12.3227 16.4901 13.2739 15.6069 13.953C14.7237 14.6321 13.6382 15.0006 12.521 15.0006C11.4038 15.0006 10.3183 14.6321 9.43511 13.953C8.55192 13.2739 7.92114 12.3227 7.64191 11.249H0.00378418C0.310879 13.666 1.49603 15.8886 3.33685 17.4998C5.17766 19.111 7.5476 20 10.0019 20C12.4562 20 14.8261 19.111 16.6669 17.4998C18.5077 15.8886 19.6929 13.666 20 11.249H17.4001Z"
      fill="white"
    />
  </svg>
  <h2>Dwoom Cloud Conference Demo</h2>
</div>

<style>
  div {
    display: flex;
    align-items: center;
    padding-left: 35px;
  }
  h2 {
    color: white;
    font-weight: 500;
    padding-left: 35px;
  }
</style>
